import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "caac-flypage-flyInfo" }
const _hoisted_2 = { class: "inner-content" }
const _hoisted_3 = { class: "flying-info-item" }
const _hoisted_4 = { class: "flying-info-item" }
const _hoisted_5 = { class: "flying-info-item" }
const _hoisted_6 = {
  key: 0,
  class: "flying-info-item"
}
const _hoisted_7 = { class: "flying-info-item" }
const _hoisted_8 = {
  key: 0,
  class: "info-item flex-row"
}
const _hoisted_9 = { class: "font-Har" }
const _hoisted_10 = { class: "font-DIN" }
const _hoisted_11 = {
  key: 1,
  class: "info-item flex-row"
}
const _hoisted_12 = { class: "font-Har" }
const _hoisted_13 = { class: "progress-item" }
const _hoisted_14 = {
  key: 0,
  class: "progress-box"
}
const _hoisted_15 = { class: "min-max-box" }
const _hoisted_16 = { class: "font-DIN-Bold" }
const _hoisted_17 = { class: "font-DIN-Bold" }
const _hoisted_18 = { class: "progress-bar" }
const _hoisted_19 = {
  key: 1,
  class: "time-info"
}

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    altitude: {
        type: [Number, String],
        default: 0
    },
    horizonalSpeed: {
        type: [Number, String],
        default: 0
    },
    courseAngle: {
        type: [Number, String],
        default: 0
    },
    angularSpeed: {
        type: [Number, String],
        default: 0
    },
    realTimeAngleOffset:{
        type: [Number, String],
        default: undefined
    },
    isMouseHidden: {
        type: Boolean,
        default: false
    },
    isReady: {
        type: Boolean,
        default: false
    },
    flyingInfo: {
        type: [Array,Object],
        default: () => []
    },
    isShowDeviation: {
        type: Boolean,
        default: true
    },
    isShowFlightInfo: {
        type: Boolean,
        default: true
    },
    showItems: {
        type: Array,
        default: () => []
    }
},
  setup(__props) {

const props = __props

const normalizedShowItems = computed(() => {
    const aliasMap: Record<string, string> = {
        altitude: 'height'
    };
    const list = (props.showItems || []) as string[];
    return list.map((item) => aliasMap[item] || item);
});

const filteredFlyingInfo = computed(() => {
    const source = (props.flyingInfo || {}) as any;
    if (Array.isArray(source)) {
        return source;
    }
    if (!normalizedShowItems.value.length) {
        return source;
    }
    const next: Record<string, any> = {};
    normalizedShowItems.value.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            next[key] = source[key];
        }
    });
    return next;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.isShowFlightInfo)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "flying-info-container",
          style: _normalizeStyle({ cursor: props.isMouseHidden ? 'none !important' : 'default !important' })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "info-title" }, "高度", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(props.altitude), 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "m", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "info-title" }, "速度", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(props.horizonalSpeed), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "m/s", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "info-title" }, "航向角", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(props.courseAngle), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "°", -1))
              ])
            ]),
            (props.realTimeAngleOffset !== undefined)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info-title" }, "航向夹角", -1)),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", null, _toDisplayString(props.realTimeAngleOffset), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("span", null, "°", -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "info-title" }, "角速度", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(props.angularSpeed), 1),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "°/s", -1))
              ])
            ])
          ])
        ], 4))
      : _createCommentVNode("", true),
    (props.isReady && props.isShowDeviation)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "deviation-info-container",
          style: _normalizeStyle({ cursor: props.isMouseHidden ? 'none !important' : 'default !important' })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFlyingInfo.value, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `fly${key}`,
              class: _normalizeClass(key == 'timeDeviation'?'time-deviation-item info-btn deviation-item':'info-btn deviation-item')
            }, [
              (key != 'timeDeviation')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(item.name), 1),
                    _createElementVNode("p", _hoisted_10, [
                      _createElementVNode("span", {
                        style: _normalizeStyle({color:item.lowerValue < item.min?'#E70102':'#FFFFFF'})
                      }, _toDisplayString(item.lowerValue), 5),
                      _cache[10] || (_cache[10] = _createTextVNode("~")),
                      _createElementVNode("span", {
                        style: _normalizeStyle({color:item.higherValue > item.max?'#E70102':'#FFFFFF'})
                      }, _toDisplayString(item.higherValue) + _toDisplayString(item.unit), 5)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(item[0]?.name), 1)
                  ])),
              _createElementVNode("div", _hoisted_13, [
                (key != 'timeDeviation')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(item.min), 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(item.max), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", {
                          class: "progress-bar-inner",
                          style: _normalizeStyle({width:`${item.progress}%`,backgroundColor:item.color, left:`${item.left}%`})
                        }, null, 4)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (childItem, childIndex) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: childIndex,
                          class: "time-info-text font-DIN"
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(childItem?.value > childItem?.max?'time-out':'none-timeout')
                          }, _toDisplayString(childItem?.value), 3),
                          _createElementVNode("span", null, "/" + _toDisplayString(childItem?.max) + _toDisplayString(childItem.unit), 1)
                        ]))
                      }), 128))
                    ]))
              ])
            ], 2))
          }), 128))
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})